import React, { useEffect, useState } from "react";
function OptionS({ onInputChange, catid, namemain, mainid, ref, defaultValuemain, edit, setStateselect }){


    const [data, setData] = useState([])
    useEffect(() => {
        getdata()
    }, [])

    const getdata = async () => {

        try {
            const sendData = {
                CatgId: Number(catid)
            }
            await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetDetailsValueState', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                        /* //console.log(data)*/
                        setData(data)
                    })

        } catch (error) {
            console.log(`Please try after some time`)
        }
    };
  return (
   
              <select
          className="form-control form-select"
          id={mainid}
          ref={ref}
          name={namemain}
          onChange={(e) => { onInputChange(e) }}
          disabled={edit}
          
      
      >
          <option value={"-1"} >{"SELECT A STATE"}  </option>
          <option value={"0"} >{"ALL STATE"} </option>

         
          {data !== [] ? data.map((optiondata, index) =>
              <option key={index} value={optiondata.catgTypeId}> {optiondata.catgDesc}</option>
              ):null

              }
              </select>

         
  );
};

export default OptionS;
